import React from "react";
import img1 from "../assets/innovation1.png";
import img2 from "../assets/innovation2.png";
import img3 from "../assets/innovation3.png";

const InnovationSection = () => {
  const sections = [
    {
      title: "EcoPro – A Patented Innovation",
      barText: "Transforms industrial, construction and plastic waste into high-performance, eco-friendly materials.",
      bullets: [
        "Environmental Responsibility: Made of 100% waste converting byproducts into valuable resources.",
        "Reduced Cost: Cost-effective alternative to market conventional products.",
        "Enhanced Durability: Superior performance, strength & longevity.",
        "Community Impact: Reduces environmental burden and supports employment opportunities.",
      ],
      image: img3,
      reverse: false,
      imageHeight: "460px",
    },
    {
      title: "Engineered For Superior Structural Performance",
      barText: "Advanced composite technology that preserves natural resources such as clay, soil, sand, cement, and water.",
      bullets: [
        "High load-bearing capacity",
        "Weather-proof, fire-resistant & long-lasting.",
        "Termite, rust and corrosion proof design.",
      ],
      image: img2,
      reverse: true,
      imageHeight: "380px",
    },
    {
      title: "Accelerating a Green Circular Economy",
      barText: "Turning waste into products that reduce landfill burden & protect the environment.",
      bullets: [
        "Reduces carbon footprint at scale.",
        "Solves industry waste-management challenges.",
        "Contributes to long-term environmental conservation.",
      ],
      image: img1,
      reverse: false,
      imageHeight: "350px",
    },
  ];

  const styles = {
    section: { padding: "4.5rem 0" },
    container: { width: "100%", maxWidth: "1250px", margin: "0 auto", padding: "0 1.5rem" },
    block: { marginBottom: "4.5rem" },
    card: {
      background: "#ffffff",
      borderRadius: "16px",
      padding: "2rem",
      boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      border: "1px solid #e5e7eb",
    },
    bar: {
      background: "#116530",
      color: "#fff",
      padding: "0.7rem 1rem",
      fontWeight: 600,
      fontSize: "1rem",
      borderRadius: "6px",
      marginBottom: "1rem",
    },
    bullet: {
      margin: "0.5rem 0",
      fontSize: "1rem",
      lineHeight: "1.55",
      color: "#374151",
    },
  };

  return (
    <section style={styles.section}>
      <div className="innovation-container">

        {sections.map((sec, index) => (
          <div key={index} style={styles.block}>

            {/* GRID WRAPPER USING RESPONSIVE CLASSES */}
            <div className={`innovation-grid ${sec.reverse ? "reverse" : ""}`}>
              {/* TEXT ALWAYS FIRST ON MOBILE BELOW 992px */}
              <div style={styles.card}>
                <h2 style={{ fontSize: "2rem", fontWeight: 700, marginBottom: "1.2rem" }}>
                  {sec.title}
                </h2>

                <div style={styles.bar}>{sec.barText}</div>

                <ul style={{ paddingLeft: "1rem" }}>
                  {sec.bullets.map((b, i) => (
                    <li key={i} style={styles.bullet}>{b}</li>
                  ))}
                </ul>
              </div>

              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img
                  src={sec.image}
                  alt={sec.title}
                  className="innovation-image"
                  style={{
                    width: "100%",
                    maxWidth: "480px",
                    height: sec.imageHeight,
                    objectFit: "contain",
                    borderRadius: "16px",
                  }}
                />
              </div>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
};

export default InnovationSection;
